import React, { useState, useEffect } from 'react';
import { useGlobal } from 'reactn';
import { Redirect, Link, useHistory } from 'react-router-dom';

import Card from '../common/card/Card';

import api from '../../api';

const EmailVerification = (props) => {
  const [verification] = useGlobal('EmailVerification');
  const history = useHistory();
 
  // Refactor useEffect dependancy function inside useEffect due to eslint warning and to prevent infinte loop.
  useEffect(() => {
    {
      const res =  api.emailVerification(props.match.params.token);
      if (res?.status === 401) return history.push('/auth/signin');
    };
  }, [history, props.match.params.token ]);

  return (
    <div>
      {verification && (
        <Card
          backgroundClass="bg-white text-center"
          title="MCWA Customer Portal Signup Confirmation"
        >
          <h1>{verification.msg || verification.error}!</h1>
          {verification.msg && <Link to="/auth/signin">Sign In &rsaquo;</Link>}
        </Card>
      )}
    </div>
  );
};

export default EmailVerification;
